import { AfterViewInit, Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-fotoweb-dialog",
  templateUrl: "./fotoweb-dialog.component.html"
})
export class FotoWebDialogComponent implements AfterViewInit {

  source: string;
  accessToken: string;
  server: string;
  widgetPath = "/fotoweb/widgets/";

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, 
    private dialogRef: MatDialogRef<FotoWebDialogComponent>) {

    this.accessToken = data.accessToken;
    this.server = data.server;
    this.source = `${this.server}${this.widgetPath}selection?access_token=${this.accessToken}`;
  }

  ngAfterViewInit(): void {
    window.addEventListener('message', this.listener.bind(this));
  }

  listener(event: any): void {

    if (event.origin != this.server) {
      return;
    }
 
    if (event.data.event === 'assetSelected') {
      this.source = `${this.server}${this.widgetPath}publish?access_token=${this.accessToken}&` + 
        `caption=false&action=false&behaviour=false&publication=false` +
        `&i=${encodeURIComponent(event.data.asset.href)}`;
    }

    if (event.data.event === 'selectionWidgetCancel') {
      this.dialogRef.close();
    }

    if (event.data.event == 'assetExported') {
      var imageURL = event.data.export.export.image.normal;
      var width = event.data.export.export.size.w;
      var height = event.data.export.export.size.h;
      this.dialogRef.close({ imageURL, width, height });
    }
  }
}
